module.exports = __webpack_public_path__ + "img/beijing17.08088e8d.jpg";